import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { getLocaleStore } from '@/i18n';
import { deleteExtraInfo } from '@/utils/layer-kit';
import {
    IActiveBaseInfo,
    IExportBehavior,
    ILayerBehavior,
    ILayerOriginInfo,
    ILayerProps,
    IRenderLayerExtraProps,
    ISize,
    LayerType,
    MIN_IMG_SIZE,
} from '@/version-types';
import QRCodeLayer from './views/layer';
import { renderLayerContentToCanvas } from './views/render-to-canvas';
import { renderLayerToPPT } from './views/render-to-ppt';
import { renderLayerToStage } from './views/render-to-stage';

function getBehavior(identity: string): ILayerBehavior {
    return {
        render(layer: ILayerProps, extraProps: IRenderLayerExtraProps) {
            return <QRCodeLayer layer={layer} {...extraProps} />;
        },

        async onBeforeSaveAsync(layer: ILayerProps, isAutoSave?: boolean) {
            deleteExtraInfo(layer);
        },

        async getResultCanvasAsync(layer: ILayerProps, stageSize: ISize): Promise<HTMLCanvasElement | undefined> {
            return renderLayerToStage(identity, layer, stageSize);
        },

        async getLayerImageAsync(layer: ILayerProps, globalAlpha = true) {
            return renderLayerContentToCanvas(identity, layer, globalAlpha);
        },

        async savePPTLayerAsync(slide, layer) {
            return renderLayerToPPT(identity, slide, layer);
        },

        whenGroupCanResize(layer: ILayerProps) {
            return {
                horizontal: true,
                vertical: true,
            };
        },

        getActiveBaseInfo(layer: ILayerProps): IActiveBaseInfo {
            return {
                cutWidth: MIN_IMG_SIZE,
                cutHeight: MIN_IMG_SIZE,
            };
        },

        getScaleMinRatio(originInfo: ILayerOriginInfo, layer: ILayerProps): number {
            const { width, cutWidth } = originInfo;
            const offWidth = width - cutWidth;

            return (width - offWidth) / width;
        },

        getScaleIsNeedLimitSize(): boolean {
            return true;
        },

        getMenuOverlapName(layer: ILayerProps) {
            const { $t } = getLocaleStore();
            return $t((v) => v.layers.qrCode);
        },
        getMenuOverlapIcon(layer: ILayerProps) {
            return (
                <div className="l-layer__icon">
                    <IconFont name="QrCodeBold" fontSize={16} />
                </div>
            );
        },
    };
}

const exportBehavior: IExportBehavior = {
    layerType: LayerType.QR_CODE,
    getBehavior,
};

export default exportBehavior;
